import { selectPageEntryById } from './entry.page-by-id.js';

const selectItemInputEntryExists = (pageId, itemId) => data => {
  const page = selectPageEntryById(pageId)(data);
  return !!page.items[itemId]?.entry;
};

export { selectItemInputEntryExists };
//# sourceMappingURL=entry.item-input-exists.js.map
